import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import LearningModuleList from '../components/LearningModuleList';
import { loadModules } from '../../../../../state/modules/learnings/actions';

const defaultLimit = 20;
const defaultOrder = 'order.asc';

const mapStateToProps = (state, ownProps) => {
  const action = ownProps.action;

  const moduleSerieId = ownProps.moduleSerieId;
  const activeId = state.careGuides.get('activeId');

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learnings.getIn(
        [
          'modules',
          activeId,
          moduleSerieId,
          action,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );
  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModules', x]),
              schema.learningModule,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    list,
    moduleSerieId,
    activeId,
    action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      careGuideId,
      moduleSerieId,
      action,
      filter,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      cb = function () {}
    ) => {
      dispatch(
        loadModules(
          careGuideId,
          moduleSerieId,
          action,
          filter,
          page,
          limit,
          order,
          (success, total) => {
            if (success) {
              // loop over all pages to get all modules
              const pageCount = Math.ceil(total / limit);

              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModules(
                    careGuideId,
                    moduleSerieId,
                    action,
                    filter,
                    i,
                    limit,
                    order
                  )
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const LearningModuleListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleList);

export default LearningModuleListContainer;
